module.exports = __webpack_public_path__ + "static/media/action-printer.6210cefa.svg";